import { Box, Button, useTheme } from "@mui/material";
import { transform } from "typescript";

interface INumberPadProps {
  onClick: (num: number) => void;
  bylaw: string;
}
const NumberPad: React.FC<INumberPadProps> = (props: INumberPadProps) => {
  const { bylaw, onClick } = props;

  const numbers = [0,1,2,3,4,5,6,7,8,9,10,11];

  const theme = useTheme();
  return (
    <Box 
      sx={{display: 'flex', width: '250px', height:'175px', flexWrap:'wrap', gap:' 0px 10px'}}>
      {
        numbers.map(num => (
          <Button
            onClick={() => onClick(num)} 
            disableRipple
            key={num}
            sx={{
              display: 'flex',
              width: '75px',
              height: '35px',
              background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              borderRadius: '4px',
              boxShadow:  '0 0 5px 2px rgba(0, 0, 0, 0.2)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              WebkitTransition: 'transform 0.2s ease, box-shadow 0.2s ease',

              color:'black',
       
              ':hover':{
                background: bylaw === 'Old' ? theme.palette.common.oldBylawHoverColor : theme.palette.common.newBylawHoverColor,
                transform: 'scale(1.05)'
              },
              ':active': {
                boxShadow: '0 1px 0 wheat',
                top: '1px',
                transition: 'box-shadow 1s ease, top 1s ease',
                WebkitTransition: 'box-shadow 1s ease, top 1s ease'
              },
              '@media screen and (max-width: 768px)': {
                ':hover':{
                  background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
                  transform: 'scale(1.00)'
                },
              },
            }}
          >
            {num}
          </Button>
        )
  
        )
      }
    </Box>
  )
}
export default NumberPad;